import SEO from "@/components/SEO";
import { Reveal, PageBand, CTABand, ConcernTile, scrollToId } from "@/components/Shared";
import { CONCERN_FAMILIES, concernsByFamily } from "@/data/concerns";
import { PAGE_HEROES } from "@/data/photos";

const scrollToFamily = (e, slug) => {
  e.preventDefault();
  scrollToId(`concern-family-${slug}`);
};

const ConcernsHub = () => (
  <>
    <SEO title="Concerns | Lumière Aesthetics, Cottesloe" description="Start with what's bothering you — pigmentation, jawline, hair thinning, sweating, first treatments. We'll tell you what can and can't be done." />
    <PageBand
      eyebrow="Concerns"
      title="Start with what's bothering you"
      standfirst="Not sure what treatment you need? Start with the concern. We'll tell you honestly what can and can't be done about it."
      image={PAGE_HEROES.concerns}
    />

    <nav aria-label="Jump to a concern group" className="bg-warm-white border-b border-hairline/60" data-testid="concerns-jump-nav">
      <div className="shell py-6 flex flex-wrap items-center gap-3">
        <span className="text-ink/50 text-xs tracking-[0.2em] uppercase mr-2">Jump to</span>
        {CONCERN_FAMILIES.map((family) => (
          <a
            key={family.slug}
            href={`#concern-family-${family.slug}`}
            onClick={(e) => scrollToFamily(e, family.slug)}
            data-testid={`jump-link-${family.slug}`}
            className="group inline-flex items-center gap-2 rounded-full border border-deep-sea/20 px-5 py-2 text-sm text-deep-sea transition-colors duration-300 hover:border-gold hover:bg-deep-sea hover:text-cream"
          >
            {family.title}
            <span className="text-xs text-ink/40 transition-colors duration-300 group-hover:text-gold">{concernsByFamily(family.slug).length}</span>
          </a>
        ))}
      </div>
    </nav>

    {CONCERN_FAMILIES.map((family, fi) => (
      <section key={family.slug} id={`concern-family-${family.slug}`} className={`scroll-mt-24 ${fi % 2 === 0 ? "bg-warm-white" : "bg-cream"}`} data-testid={`concern-family-${family.slug}`}>
        <div className="shell py-20">
          <Reveal className="mb-10">
            <h2 className="text-deep-sea">{family.title}</h2>
            <p className="text-ink/70 text-sm mt-3">{family.blurb}</p>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {concernsByFamily(family.slug).map((c, i) => (
              <ConcernTile key={c.slug} concern={c} index={i} />
            ))}
          </div>
        </div>
      </section>
    ))}

    <CTABand />
  </>
);

export default ConcernsHub;
